// Be blessed those who reduce but not increase the size of this file.

/*
This function is used to eliminate unnecessary re-render when the user resizes Roadmap sections.

react-virtualized List doesn't have an option to say "please change your width but don't call
rowRenderer as I know that my rows don't depend on width directly". Thus in such situation, we don't
update List at all and just set its width manually directly in the DOM.

It's very brittle; please keep an eye on it while updating react-virtualized version.

Calling it from shouldComponentUpdate is against the law; please don't repeat at home as you might
be charged and sent to jail by React Evangelism Forces.
*/
export const manuallyUpdateReactVirtualizedListWidth = (
	container: HTMLElement,
	newWidth: number,
) => {
	const width = `${newWidth}px`;
	const grid: HTMLElement | null = container.querySelector('.ReactVirtualized__Grid');
	if (grid) {
		grid.style.width = width;
		const scroll: HTMLElement | null = grid.querySelector(
			'.ReactVirtualized__Grid__innerScrollContainer',
		);
		if (scroll) scroll.style.maxWidth = width;
	}
};

export const manuallyUpdateStickyHeaderWidth = (elementId: string, newWidth: number) => {
	const width = `${newWidth}px`;
	const stickyHeader = document.getElementById(elementId);
	if (stickyHeader) {
		stickyHeader.style.width = width;
	}
};
